var PreferencesController = /** @class */ (function () {
    function PreferencesController() {
        this.listeners = [];
    }
    PreferencesController.prototype.addListener = function (listener) {
        this.listeners.push(listener);
    };
    PreferencesController.prototype.removeListener = function (listener) {
        var index = this.listeners.indexOf(listener);
        if (index < 0) {
            return false;
        }
        this.listeners.splice(index, 1);
        return true;
    };
    PreferencesController.prototype.confirm = function () {
        this.callListeners('onConfirm');
    };
    PreferencesController.prototype.cancel = function () {
        this.callListeners('onCancel');
    };
    PreferencesController.prototype.callListeners = function (type) {
        this.listeners.forEach(function (listener) {
            if (listener.hasOwnProperty(type)) {
                listener[type]();
            }
        });
    };
    return PreferencesController;
}());
export default PreferencesController;
//# sourceMappingURL=controller.js.map